import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, MultiSelection, Selection } from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { FaTag } from 'react-icons/fa';
import SettingsCardWrapper from './SettingsCardWrapper';
import {
  classificationFormatter,
  classificationSelectionFormatter,
} from '../shared/formatters';
import css from '../../styles.css';

function ClassificationSettingsCard({ classificationTypeOptions, pending }) {
  const { formatMessage } = useIntl();
  const [libraryClassificationTypes, setLibraryClassificationTypes] = useState(
    [],
  );

  return (
    <SettingsCardWrapper
      titleId="ui-plugin-inventory-templates.templatesOtherSettings.sections.classificationSettings"
      defaultTitle="Classification Settings"
      icon={FaTag}
    >
      <Row>
        <Col xs={12}>
          <Field
            id="libraryClassificationTypes"
            name="classification.libraryClassificationTypes"
            component={MultiSelection}
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesOtherSettings.fields.libraryClassificationTypes"
                defaultMessage="Library classification types"
              />
            }
            placeholder={formatMessage({
              id: 'ui-plugin-inventory-templates.templatesOtherSettings.fields.libraryClassificationTypes.placeholder',
              defaultMessage: 'Select classification types',
            })}
            dataOptions={classificationTypeOptions}
            formatter={classificationFormatter(formatMessage)}
            loading={pending}
            disabled={pending}
            fullWidth
          />
        </Col>
      </Row>

      <OnChange name="classification.libraryClassificationTypes">
        {(value) => {
          setLibraryClassificationTypes(value || []);
        }}
      </OnChange>

      <Row>
        <Col xs={12}>
          <Field
            id="preferredClassificationType"
            name="classification.preferredClassificationType"
            component={Selection}
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templatesOtherSettings.fields.preferredClassificationType"
                defaultMessage="Preferred classification type"
              />
            }
            placeholder={formatMessage({
              id: 'ui-plugin-inventory-templates.templatesOtherSettings.fields.preferredClassificationType.placeholder',
              defaultMessage: 'Select preferred type',
            })}
            dataOptions={libraryClassificationTypes}
            formatter={classificationSelectionFormatter(formatMessage)}
            loading={pending}
            disabled={pending || libraryClassificationTypes.length === 0}
            fullWidth
          />
        </Col>
        <Col
          className={css.infoMsg}
          style={{ fontSize: '14px', marginTop: '8px' }}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.templatesOtherSettings.sections.classificationSettings.info"
            defaultMessage="Select the classification types used by your library, then choose your preferred type. The preferred classification type will be automatically used to complete call number fields for holdings and items creation."
          />
        </Col>
      </Row>
    </SettingsCardWrapper>
  );
}

ClassificationSettingsCard.propTypes = {
  classificationTypeOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  pending: PropTypes.bool.isRequired,
};

export default ClassificationSettingsCard;
